"use client";

import { usePathname } from "next/navigation";
import Comments from "../../../_components/comments/Comments";

const CommentsButton = ({
  groupId,
  userId,
}: {
  groupId: string | null;
  userId: string;
}) => {
  const pathname = usePathname();

  return (
    <Comments
      subjectId={""}
      groupId={groupId}
      userId={userId}
      subject={pathname}
      key={pathname}
    />
  );
};

export default CommentsButton;
